import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Eye, Droplets } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { TreatmentsCarousel } from './TreatmentsCarousel';
export function ServicesMenu() {
  const {
    t
  } = useLanguage();
  const serviceImages: Record<string, string> = {
    [t('services.s1_name')]: 'https://cdn.magicpatterns.com/uploads/rhkH99xdykiLyX7WK9kgLJ/TRATAMIENTO_PROFUNDO.png',
    [t('services.s2_name')]: 'https://cdn.magicpatterns.com/uploads/uxXLsvBF3BgAdf29eq4Gjh/HYDRAFACIAL.png',
    [t('services.s5_name')]: 'https://cdn.magicpatterns.com/uploads/6Sfbim9J4kUbv54WTwoR3m/CARBOXY_TERAPIA.png',
    [t('services.s8_name')]: 'https://cdn.magicpatterns.com/uploads/73HutjDmfRhRP3wGvZQiCo/PEEL_QUIMICO.png',
    [t('services.s10_name')]: 'https://cdn.magicpatterns.com/uploads/vgYJ4aJDw8n7TosnbZ5H83/DERMAPLANING.png',
    [t('services.s7_name')]: 'https://cdn.magicpatterns.com/uploads/dYzfpzo79VLeg8fCsbKdU5/TRATAMIENTO_FACIAL.png',
    [t('services.s9_name')]: 'https://cdn.magicpatterns.com/uploads/6jueZi8VWt5vdpNotgUdpF/GREEN_PEEL.png',
    [t('services.o3_name')]: 'https://cdn.magicpatterns.com/uploads/541fLq17Gm13GDNttSXou7/JELLY_MASK.png',
    [t('services.o4_name')]: 'https://cdn.magicpatterns.com/uploads/oNYbmg7vts7obM4iTR8pVH/EXTRACCIONES_EN_UN_SOLO_LUGAR.png',
    [t('services.o5_name')]: 'https://cdn.magicpatterns.com/uploads/khCnfqFyPUNMW416u5s4KK/REMOCION_DE_VERRUGAS.png'
  };
  const mainServices = [{
    name: t('services.s1_name'),
    desc: t('services.s1_desc')
  }, {
    name: t('services.s2_name'),
    desc: t('services.s2_desc')
  }, {
    name: t('services.s3_name'),
    desc: t('services.s3_desc')
  }, {
    name: t('services.s4_name'),
    desc: t('services.s4_desc')
  }, {
    name: t('services.s5_name'),
    desc: t('services.s5_desc')
  }, {
    name: t('services.s6_name'),
    desc: t('services.s6_desc')
  }, {
    name: t('services.s7_name'),
    desc: t('services.s7_desc')
  }, {
    name: t('services.s8_name'),
    desc: t('services.s8_desc')
  }, {
    name: t('services.s9_name'),
    desc: t('services.s9_desc')
  }, {
    name: t('services.s10_name'),
    desc: t('services.s10_desc')
  }, {
    name: t('services.s11_name'),
    desc: t('services.s11_desc')
  }, {
    name: t('services.s12_name'),
    desc: t('services.s12_desc')
  }, {
    name: t('services.s13_name'),
    desc: t('services.s13_desc')
  }, {
    name: t('services.s14_name'),
    desc: t('services.s14_desc')
  }, {
    name: t('services.s15_name'),
    desc: t('services.s15_desc')
  }];
  const otherServices = [{
    name: t('services.o1_name'),
    desc: t('services.o1_desc')
  }, {
    name: t('services.o2_name'),
    desc: t('services.o2_desc')
  }, {
    name: t('services.o3_name'),
    desc: t('services.o3_desc')
  }, {
    name: t('services.o4_name'),
    desc: t('services.o4_desc')
  }, {
    name: t('services.o5_name'),
    desc: t('services.o5_desc')
  }];
  return <section id="servicios" className="py-12 md:py-24 bg-brand-cream relative" data-id="element-386" data-mp="1tcl0oc96n3rc">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-387" data-mp="1tep30prfnupi">
        <div className="text-center mb-10 md:mb-16" data-id="element-388" data-mp="1oe9ss72g73br">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-389" data-mp="1jmrrtj0fd2qs">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-390" data-mp="1an4nopgb9iu1">
              {t('services.title')}
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full mb-6" data-id="element-391" data-mp="10o73tzttydhd"></div>
            <p className="text-brand-charcoal max-w-2xl mx-auto mb-8" data-id="element-392" data-mp="10q9sogj8y0ki">
              {t('services.subtitle')}
            </p>
            <a href="https://book.heygoldie.com/tairu-aesthetics" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-brand-gold hover:bg-brand-gold-light text-white px-8 py-3 rounded-sm font-medium transition-colors duration-300 shadow-sm text-sm" data-id="element-393" data-mp="2v1y7mipha34w">
              <Sparkles className="w-4 h-4" data-id="element-394" data-mp="332w52l9u02ci" />
              {t('header.bookNow')}
            </a>
          </motion.div>
        </div>

        {/* Treatments Carousel */}
        <TreatmentsCarousel data-id="element-395" data-mp="2o5dinpkmm188" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-396" data-mp="2t4q5497l56aa">
          {/* Main Services List */}
          <motion.div className="lg:col-span-8" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-397" data-mp="2fdbi7rak4kxy">
            <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10 h-full" data-id="element-398" data-mp="25dayi48s02t8">
              <div className="flex items-center gap-3 mb-8 pb-4 border-b border-brand-gold/20" data-id="element-399" data-mp="2abw2mer5f6my">
                <Sparkles className="w-6 h-6 text-brand-gold" data-id="element-400" data-mp="1wgtnd10ew4xh" />
                <h3 className="text-2xl font-serif text-brand-brown" data-id="element-401" data-mp="20fj6zbc1mipk">
                  {t('services.main_title')}
                </h3>
              </div>

              <div className="divide-y divide-brand-gold/10" data-id="element-402" data-mp="1csxif6rhp4nl">
                {mainServices.map((service, idx) => <div key={idx} className="flex items-start gap-4 md:gap-6 py-5 first:pt-0 last:pb-0 group" data-id="element-403" data-mp="1qs6sdop3r2j4" data-mpi={idx}>
                    {serviceImages[service.name] && <div className="w-24 h-28 md:w-32 md:h-36 flex-shrink-0 overflow-hidden rounded-sm border border-brand-gold/30 shadow-sm" data-id="element-404" data-mp="1lrsmac72a2nq">
                        <img src={serviceImages[service.name]} alt={service.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110" data-id="element-405" data-mp="1vrjkooyqt1t3" />
                      </div>}
                    <div className="flex-1 min-w-0" data-id="element-406" data-mp="25ie3tkgozlab">
                      <h4 className="font-semibold text-brand-charcoal mb-1 group-hover:text-brand-gold transition-colors" data-id="element-407" data-mp="25jpapt5fp95n">
                        {service.name}
                      </h4>
                      <p className="text-sm text-gray-600 leading-relaxed" data-id="element-408" data-mp="2efwwnb0kv3wr">
                        {service.desc}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>
          </motion.div>

          {/* Sidebar Services */}
          <motion.div className="lg:col-span-4 space-y-8" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-409" data-mp="1l3yqwlk8ghjs">
            {/* Eyes & Brows */}
            <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10" data-id="element-410" data-mp="23vrkah37s4s1">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-brand-gold/20" data-id="element-411" data-mp="23ty9cplkiye8">
                <Eye className="w-6 h-6 text-brand-gold" data-id="element-412" data-mp="28shzz3b3wycx" />
                <h3 className="text-xl font-serif text-brand-brown" data-id="element-413" data-mp="9j1ofttacli0">
                  {t('services.eyes_title')}
                </h3>
              </div>

              <div className="space-y-6" data-id="element-414" data-mp="6x243f49awg9">
                <div data-id="element-415" data-mp="6y3qugumx7dt">
                  <h4 className="font-semibold text-brand-charcoal mb-1" data-id="element-416" data-mp="6zeu8fk64d4e">
                    {t('services.e1_name')}
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-417" data-mp="3tcdcii76k1aw">
                    {t('services.e1_desc')}
                  </p>
                </div>
                <div data-id="element-418" data-mp="3ofemaaqn0ehz">
                  <h4 className="font-semibold text-brand-charcoal mb-1" data-id="element-419" data-mp="3obz3awtuelba">
                    {t('services.e2_name')}
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-420" data-mp="kwtn5u9mr314">
                    {t('services.e2_desc')}
                  </p>
                </div>
              </div>
            </div>

            {/* Other Services */}
            <div className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10" data-id="element-421" data-mp="bvdg9wi0xj1n">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-brand-gold/20" data-id="element-422" data-mp="30pagpxtw24oc">
                <Droplets className="w-6 h-6 text-brand-gold" data-id="element-423" data-mp="2wlkw1jgc478l" />
                <h3 className="text-xl font-serif text-brand-brown" data-id="element-424" data-mp="zlzw2xkv1tu4">
                  {t('services.other_title')}
                </h3>
              </div>

              <div className="divide-y divide-brand-gold/10" data-id="element-425" data-mp="14mnx8c2szr22">
                {otherServices.map((service, idx) => <div key={idx} className="flex items-start gap-4 py-4 first:pt-0 last:pb-0 group" data-id="element-426" data-mp="qmwcztlp1efm" data-mpi={idx}>
                    {serviceImages[service.name] && <div className="w-20 h-24 flex-shrink-0 overflow-hidden rounded-sm border border-brand-gold/30 shadow-sm" data-id="element-427" data-mp="vm96uyazflrp">
                        <img src={serviceImages[service.name]} alt={service.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110" data-id="element-428" data-mp="1nbu6z9lmd8bq" />
                      </div>}
                    <div className="flex-1 min-w-0" data-id="element-429" data-mp="1ehpn5a4wkx5p">
                      <h4 className="font-semibold text-brand-charcoal text-sm" data-id="element-430" data-mp="2294op0ouvafw">
                        {service.name}
                      </h4>
                      <p className="text-xs text-gray-600" data-id="element-431" data-mp="2714l4j5pvl7q">{service.desc}</p>
                    </div>
                  </div>)}
              </div>
            </div>

          </motion.div>
        </div>
      </div>
    </section>;
}